<!--部门信息管理-->
<template>
  <div class="fun">
    <el-button-group>
      <el-button v-if="this.$fun.isQx(this.qx, 'depa:add')" type="primary" icon="Plus" @click="addInfo">添加</el-button>
      <el-button v-if="this.$fun.isQx(this.qx, 'depa:del')" type="danger" icon="Delete" @click="delInfo">删除</el-button>
      <el-button v-if="this.$fun.isQx(this.qx, 'depa:enable')" type="success" icon="CircleCheck" @click="enableInfo(true)">启用</el-button>
      <el-button v-if="this.$fun.isQx(this.qx, 'depa:enable')" type="info" icon="CircleClose" @click="enableInfo(false)">禁用</el-button>
    </el-button-group>
    <STC colName="depaColumn" :colList="colList" />
  </div>
  <el-table v-loading="tableLoading" :data="tableData" highlight-current-row stripe border row-key="id" default-expand-all
      :height="tableHeight" style="width: 100%" @current-change="handleCurrentChange"
      header-row-class-name="header-row" header-cell-class-name="header-cell">
    <el-table-column v-if="this.$fun.isExist(checkColList, '序')" type="index" label="序" width="40"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '部门名称')" prop="name" label="部门名称" width="200"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '负责人')" prop="manager" label="负责人" width="150"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '部门电话')" prop="phone" label="部门电话" show-overflow-tooltip width="250"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '详细地址')" prop="address" label="详细地址" show-overflow-tooltip></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '排序')" prop="queue" label="排序" width="60"></el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '状态')" label="状态" width="60">
      <template #default="scope">
        <el-icon v-if="scope.row.isEnable" class="check" title="启用"><Check /></el-icon>
        <el-icon v-else class="close" title="禁用"><Close /></el-icon>
      </template>
    </el-table-column>
    <el-table-column v-if="this.$fun.isExist(checkColList, '录入时间')" prop="upTime" label="录入时间" sortable width="150"></el-table-column>
    <el-table-column width="100">
      <template #header>
        操作
      </template>
      <template #default="scope">
        <el-button v-if="this.$fun.isQx(this.qx, 'depa:edit')" text type="primary" @click="editInfo(scope.row.id)">修改</el-button>
      </template>
    </el-table-column>
  </el-table>
  <el-dialog :title="dialogTitle" v-model="dialogFormVisible" :close-on-click-modal="false" :before-close="closeForm">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="130px">
      <input v-model="form.id" type="hidden">
      <el-form-item label="部门名称" prop="name">
          <el-input v-model="form.name" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item label="上级部门" prop="parentId">
        <el-tree-select v-model="form.parentId" :data="depaData" placeholder="请选择一个部门"
          highlight-current default-expand-all />
      </el-form-item>
      <el-form-item label="负责人" prop="manager">
          <el-input v-model="form.manager" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item label="部门电话" prop="phone">
          <el-input v-model="form.phone" maxlength="50" class="width"></el-input>
      </el-form-item>
      <el-form-item label="详细地址" prop="address">
          <el-input v-model="form.address" maxlength="100"></el-input>
      </el-form-item>
      <el-form-item label="描 述" prop="desc">
        <el-input v-model="form.desc " type="textarea"></el-input>
      </el-form-item>
      <el-form-item label="排序">
        <el-input-number v-model="form.queue" :min="0" />
      </el-form-item>
    </el-form>
    <template #footer>
    <span class="dialog-footer">
      <el-button @click="closeForm">关 闭</el-button>
      <el-button @click="resetForm">重 填</el-button>
      <el-button type="primary" @click="saveInfo">确 定</el-button>
    </span>
  </template>
    </el-dialog>
</template>

<script>
// 选择显示的表列
import STC from '@/components/SelectTableColumn'
export default {
  name: 'depa',
  components: {
    STC
  },
  data () {
    var validateParentId = (rule, value, callback) => {
      // var val = this.form.type
      if (!this.isAdd && this.selectionIds === value) {
        callback(new Error('上级部门不能选择本部门!'))
      } else {
        callback()
      }
    }
    return {
      qx: '',
      colList: ['序', '部门名称', '负责人', '部门电话', '详细地址', '排序', '状态', '录入时间'],
      checkColList: [],
      tableLoading: false,
      currentPage: 1,
      pagesize: 4,
      tableTotal: 0,
      tableData: [],
      selectionIds: '',
      isAdd: true,
      dialogFormVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        name: '',
        parentId: '',
        manager: '',
        phone: '',
        address: '',
        desc: '',
        queue: 0
      },
      rules: {
        name: [
          { required: true, message: '请输入部门名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        parentId: [
          { required: true, message: '请选择上级部门', trigger: 'blur' },
          { validator: validateParentId, trigger: 'blur' }
        ]
      },
      // 上级模块数据
      depaData: []
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    this.qx = this.$route.params.qx
    this.getTableHeight()
    this.getData()
  },
  methods: {
    handleCurrentChange (val) {
      // this.currentRow = val
      if (val !== undefined) {
        this.selectionIds = val.id
      }
    },
    async getData () {
      this.tableLoading = true
      const { data: ret } = await this.$http.get(this.$api.depalist)
      if (ret.status === 0) {
        this.tableData = ret.data.rows
        this.tableTotal = ret.data.total
      }
      this.tableLoading = false
    },
    async getDepaData () {
      const { data: ret } = await this.$http.get(this.$api.depadowndepa + '?bo=' + true)
      if (ret.status === 0) {
        if (ret.data === null) {
          this.$message({
            message: ret.message,
            type: 'warning'
          })
          return
        }
        this.depaData = [ret.data]
      }
    },
    addInfo () {
      this.isAdd = true
      this.form.id = ''
      this.dialogTitle = '添加部门信息'
      this.dialogFormVisible = true
      this.getDepaData()
    },
    async editInfo (id) {
      this.isAdd = false
      // if (this.selectionIds === '') {
      //   this.$message.error('请选择一条信息修改。')
      //   return
      // }
      this.dialogFormVisible = true
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        // spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.getDepaData()
      const { data: ret } = await this.$http.get(this.$api.depaid + '/' + id)
      if (ret.status === 0) {
        const obj = ret.data
        Object.keys(this.form).forEach(key => {
          this.form[key] = obj[key]
        })
        this.dialogTitle = '修改部门信息'
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    saveInfo () {
      this.$refs.formRef.validate(async (valid) => {
        if (valid) {
          // console.log('form=', this.form)
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          })
          const { data: ret } = await this.$http.post(this.$api.depasave, this.form)
          if (ret.status === 0) {
            this.$message.success(ret.message)
            this.getData()
            this.closeForm()
          } else {
            this.$message.error(ret.message)
          }
          loading.close()
        } else {
          this.$message.error('验证没通过。')
          return false
        }
      })
    },
    delInfo () {
      if (this.selectionIds === '') {
        this.$message.error('请选择将删除的信息。')
        return
      }
      this.$confirm('此操作将删除已选择的信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        const { data: ret } = await this.$http.post(this.$api.depadel + '?ids=' + this.selectionIds)
        if (ret.status === 0) {
          this.getData()
          this.$message.success(ret.message)
        } else {
          this.$message.error(ret.message)
        }
        loading.close()
      })
    },
    async enableInfo (bo) {
      const s = bo ? '启用' : '禁用'
      if (this.selectionIds === '') {
        this.$message.error('请选择将' + s + '的信息。')
        return
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      const params = '?ids=' + this.selectionIds + '&bo=' + bo
      // console.log(params)
      const { data: ret } = await this.$http.post(this.$api.depaenable + params)
      if (ret.status === 0) {
        this.getData()
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
      loading.close()
    },
    resetForm () {
      this.$refs.formRef.resetFields()
    },
    closeForm () {
      this.$refs.formRef.resetFields()
      this.dialogFormVisible = false
    },
    // 部门信息上级pid
    // handleNodeClick (data) {
    //   // console.log('NodeClick=', data)
    //   // console.log('data=', data.id)
    //   this.form.parentId = data.id
    // },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 87
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style>

</style>
